const ProgressIndicator = ({ currentStep, totalSteps }: any) => {
  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div className="flex flex-col items-start">
      <p>
        <span className="text-[#4B4AD5] font-semibold">Step {currentStep}</span>{" "}
        of {totalSteps}
      </p>
      <div
        style={{
          width: "100%",
          backgroundColor: "#e0e0e0",
          borderRadius: "100px",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            backgroundColor: "#4B4AD5",
            height: "3px",
            borderRadius: "100px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
